// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KazooTasksPage_pageWrap__itl6N .KazooTasksPage_pageHeader__uzT2q {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid var(--border);
  margin-bottom: 16px;
}
.KazooTasksPage_pageWrap__itl6N .KazooTasksPage_pageHeader__uzT2q h1 {
  font: var(--h3);
  font-weight: 700;
  color: var(--primary-Text);
  font-family: var(--font-bodoni-72);
}
.KazooTasksPage_pageWrap__itl6N .KazooTasksPage_pageHeader__uzT2q .KazooTasksPage_right__7AHzN {
  display: flex;
  align-items: center;
  gap: 20px;
}
.KazooTasksPage_pageWrap__itl6N .KazooTasksPage_pageHeader__uzT2q .KazooTasksPage_right__7AHzN .KazooTasksPage_date__OZgLP {
  display: flex;
  align-items: center;
  gap: 4px;
}
.KazooTasksPage_pageWrap__itl6N .KazooTasksPage_pageHeader__uzT2q .KazooTasksPage_right__7AHzN .KazooTasksPage_date__OZgLP img,
.KazooTasksPage_pageWrap__itl6N .KazooTasksPage_pageHeader__uzT2q .KazooTasksPage_right__7AHzN .KazooTasksPage_date__OZgLP svg {
  width: 16px;
  height: 16px;
  object-fit: scale-down;
  display: block;
}
.KazooTasksPage_pageWrap__itl6N .KazooTasksPage_pageHeader__uzT2q .KazooTasksPage_right__7AHzN .KazooTasksPage_date__OZgLP span {
  font: var(--body-font-four);
  color: var(--primary-Text);
  display: block;
}
.KazooTasksPage_pageWrap__itl6N .KazooTasksPage_tableWrap__XR0WU {
  padding: 0 24px;
}

.KazooTasksPage_InviteModalInner__Pl0Ba .KazooTasksPage_csvAddRow__pKoXe {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  margin-bottom: 15px;
}
.KazooTasksPage_InviteModalInner__Pl0Ba .KazooTasksPage_addFieldWrp__ZIa84 {
  max-height: 300px;
  overflow-y: auto;
}
.KazooTasksPage_InviteModalInner__Pl0Ba .KazooTasksPage_addFieldRow__H25L1 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  margin-bottom: 15px;
  width: 100%;
}
.KazooTasksPage_InviteModalInner__Pl0Ba .KazooTasksPage_addFieldRow__H25L1 .KazooTasksPage_row__Dfjrg {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding-top: 2px;
}
.KazooTasksPage_InviteModalInner__Pl0Ba .KazooTasksPage_addFieldRow__H25L1 .KazooTasksPage_row__Dfjrg .KazooTasksPage_input__z4Pp9 {
  max-width: 287px;
  width: 100%;
}
.KazooTasksPage_InviteModalInner__Pl0Ba .KazooTasksPage_addFieldRow__H25L1 .KazooTasksPage_row__Dfjrg .KazooTasksPage_role__o9cit {
  min-width: 170px;
}
.KazooTasksPage_InviteModalInner__Pl0Ba .KazooTasksPage_addFieldRow__H25L1 .KazooTasksPage_row__Dfjrg .KazooTasksPage_deleteBtn__twMHk {
  width: 40px;
  height: 40px;
}
.KazooTasksPage_InviteModalInner__Pl0Ba .KazooTasksPage_addFieldRow__H25L1 .KazooTasksPage_row__Dfjrg .KazooTasksPage_deleteBtn__twMHk button {
  padding: 10px;
}
.KazooTasksPage_InviteModalInner__Pl0Ba .KazooTasksPage_addFieldRow__H25L1 .KazooTasksPage_row__Dfjrg > div:first-child {
  flex: 1 1;
}
.KazooTasksPage_InviteModalInner__Pl0Ba .KazooTasksPage_addFieldRow__H25L1 .KazooTasksPage_row__Dfjrg > div:first-child .KazooTasksPage_input__z4Pp9 {
  max-width: 100%;
}

.KazooTasksPage_formWrp__x4IGS {
  max-height: 550px;
  overflow-y: auto;
}
.KazooTasksPage_formWrp__x4IGS .KazooTasksPage_formField__RbjgL .KazooTasksPage_label__OT6aC {
  font: var(--body-font-three);
  color: var(--secondary-Text);
  display: block;
  margin-bottom: 4px;
}
.KazooTasksPage_formWrp__x4IGS .KazooTasksPage_prioritySelect__kNt0x {
  display: flex;
  align-items: center;
  gap: 5px;
  font: var(--body-font-four);
  font-weight: 500;
  text-transform: capitalize;
  color: var(--primary-Text);
}
.KazooTasksPage_formWrp__x4IGS .KazooTasksPage_prioritySelect__kNt0x img,
.KazooTasksPage_formWrp__x4IGS .KazooTasksPage_prioritySelect__kNt0x svg {
  width: 16px;
  height: 16px;
  object-fit: scale-down;
  display: block;
}
.KazooTasksPage_formWrp__x4IGS .KazooTasksPage_fileUploadedList__Kdmqr {
  padding: 12px;
  width: 100%;
  justify-content: flex-start;
}
.KazooTasksPage_formWrp__x4IGS .KazooTasksPage_fileUploadedList__Kdmqr span {
  color: var(--brand);
  flex: 1 1;
}

.KazooTasksPage_taskEditModal__bB0FU .KazooTasksPage_subHeading__NF5PL {
  font-weight: 600;
  font-size: var(--h6);
  color: var(--primary-Text);
  margin-bottom: 20px;
  text-align-last: left;
}

.KazooTasksPage_taskTitleInput__sNIKP {
  width: 100%;
  border: 1px solid var(--Stroke-Color, #E8EBEE);
  border-radius: 8px;
  padding: 8px 12px;
  background: #fff;
  font: var(--body-font-three);
  color: #000;
  margin: 0;
  outline: none;
}
.KazooTasksPage_taskTitleInput__sNIKP::placeholder {
  color: var(--secondary-Text);
}
.KazooTasksPage_taskTitleInput__sNIKP:focus {
  border-color: #7CA6BD;
}

.KazooTasksPage_taskDetailsModal__pN27G .KazooTasksPage_subHeading__NF5PL {
  font-weight: 600;
  font-size: var(--h6);
  color: var(--primary-Text);
  margin-bottom: 20px;
  text-align-last: left;
}
.KazooTasksPage_taskDetailsModal__pN27G .KazooTasksPage_assignedToRow__XLL0b {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 4px;
}
.KazooTasksPage_taskDetailsModal__pN27G .KazooTasksPage_assignedToRow__XLL0b li {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 5px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
}
.KazooTasksPage_taskDetailsModal__pN27G .KazooTasksPage_assignedToRow__XLL0b li img,
.KazooTasksPage_taskDetailsModal__pN27G .KazooTasksPage_assignedToRow__XLL0b li svg {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}
.KazooTasksPage_taskDetailsModal__pN27G .KazooTasksPage_dueDate__ao\\+X9 {
  font-weight: 500;
  font-size: var(--body-font-three);
  color: var(--primary-Text);
}
.KazooTasksPage_taskDetailsModal__pN27G .KazooTasksPage_status__KA99n {
  background-color: var(--white);
}
.KazooTasksPage_taskDetailsModal__pN27G .KazooTasksPage_comment__NSBLL {
  font-weight: 500;
  font-size: var(--body-font-three);
  color: var(--primary-Text);
}
.KazooTasksPage_taskDetailsModal__pN27G .KazooTasksPage_fileUploadedList__Kdmqr span {
  color: var(--primary-Text);
}

.KazooTasksPage_deleteModal__J3PqV .KazooTasksPage_modalBtns__VKHWk {
  display: flex;
  justify-content: center;
  gap: 16px;
}

@media (max-height: 820px) {
  .KazooTasksPage_formWrp__x4IGS {
    max-height: 450px;
    overflow-y: auto;
  }
}
@media (max-width: 767px) {
  .KazooTasksPage_pageWrap__itl6N .KazooTasksPage_pageHeader__uzT2q {
    padding: 16px;
  }
  .KazooTasksPage_pageWrap__itl6N .KazooTasksPage_pageHeader__uzT2q .KazooTasksPage_right__7AHzN {
    gap: 12px;
  }
  .KazooTasksPage_pageWrap__itl6N .KazooTasksPage_pageHeader__uzT2q .KazooTasksPage_right__7AHzN button {
    min-height: 35px;
    padding: 7px 10px;
    font-size: 12px;
    text-align: center;
  }
  .KazooTasksPage_pageWrap__itl6N .KazooTasksPage_tableWrap__XR0WU {
    padding: 0 16px;
  }
  .KazooTasksPage_InviteModalInner__Pl0Ba .KazooTasksPage_csvAddRow__pKoXe button {
    font-size: 12px !important;
  }
}
@media (max-width: 600px) {
  .KazooTasksPage_InviteModalInner__Pl0Ba .KazooTasksPage_addFieldRow__H25L1 .KazooTasksPage_row__Dfjrg {
    flex-wrap: wrap;
  }
  .KazooTasksPage_InviteModalInner__Pl0Ba .KazooTasksPage_addFieldRow__H25L1 .KazooTasksPage_row__Dfjrg .KazooTasksPage_role__o9cit {
    order: 3;
    width: 100%;
  }
  .KazooTasksPage_InviteModalInner__Pl0Ba .KazooTasksPage_addFieldRow__H25L1 .KazooTasksPage_row__Dfjrg .KazooTasksPage_deleteBtn__twMHk {
    width: 35px;
    height: 35px;
    flex-shrink: 0;
  }
  .KazooTasksPage_InviteModalInner__Pl0Ba .KazooTasksPage_addFieldRow__H25L1 .KazooTasksPage_row__Dfjrg .KazooTasksPage_deleteBtn__twMHk button {
    min-height: auto;
    width: 100%;
    padding: 2px;
    height: 100%;
  }
  .KazooTasksPage_InviteModalInner__Pl0Ba .KazooTasksPage_row__Dfjrg > div:first-child {
    flex: 1 1;
  }
  .KazooTasksPage_InviteModalInner__Pl0Ba .KazooTasksPage_row__Dfjrg > div:first-child .KazooTasksPage_input__z4Pp9 {
    max-width: 100%;
  }
}
@media (max-width: 425px) {
  .KazooTasksPage_pageWrap__itl6N .KazooTasksPage_pageHeader__uzT2q .KazooTasksPage_right__7AHzN .KazooTasksPage_date__OZgLP span {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/tasks/KazooTasksPage.module.scss"],"names":[],"mappings":"AACC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,sCAAA;EACA,mBAAA;AAAF;AAEE;EACC,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kCAAA;AAAH;AAGE;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AADH;AAGG;EACC,aAAA;EACA,mBAAA;EACA,QAAA;AADJ;AAGI;;EAEC,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AADL;AAII;EACC,2BAAA;EACA,0BAAA;EACA,cAAA;AAFL;AAQC;EACC,eAAA;AANF;;AAWC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AARF;AAWC;EACC,iBAAA;EACA,gBAAA;AATF;AAYC;EACC,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;AAVF;AAYE;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;AAVH;AAYG;EACC,gBAAA;EACA,WAAA;AAVJ;AAaG;EACC,gBAAA;AAXJ;AAcG;EACC,WAAA;EACA,YAAA;AAZJ;AAcI;EACC,aAAA;AAZL;AAiBE;EACC,SAAA;AAfH;AAiBG;EACC,eAAA;AAfJ;;AAqBA;EACC,iBAAA;EACA,gBAAA;AAlBD;AAqBE;EACC,4BAAA;EACA,4BAAA;EACA,cAAA;EACA,kBAAA;AAnBH;AAuBC;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,2BAAA;EACA,gBAAA;EACA,0BAAA;EACA,0BAAA;AArBF;AAuBE;;EAEC,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AArBH;AAyBC;EACC,aAAA;EACA,WAAA;EACA,2BAAA;AAvBF;AAyBE;EACC,mBAAA;EACA,SAAA;AAvBH;;AA6BC;EACC,gBAAA;EACA,oBAAA;EACA,0BAAA;EACA,mBAAA;EACA,qBAAA;AA1BF;;AA8BA;EACC,WAAA;EACA,8CAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;AA3BD;AA6BC;EACC,4BAAA;AA3BF;AA8BC;EACC,qBAAA;AA5BF;;AAiCC;EACC,gBAAA;EACA,oBAAA;EACA,0BAAA;EACA,mBAAA;EACA,qBAAA;AA9BF;AAiCC;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AA/BF;AAiCE;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AA/BH;AAiCG;;EAEC,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;AA/BJ;AAoCC;EACC,gBAAA;EACA,iCAAA;EACA,0BAAA;AAlCF;AAqCC;EACC,8BAAA;AAnCF;AAsCC;EACC,gBAAA;EACA,iCAAA;EACA,0BAAA;AApCF;AAwCE;EACC,0BAAA;AAtCH;;AA4CC;EACC,aAAA;EACA,uBAAA;EACA,SAAA;AAzCF;;AA6CA;EACC;IACC,iBAAA;IACA,gBAAA;EA1CA;AACF;AA6CA;EAEE;IACC,aAAA;EA5CD;EA8CC;IACC,SAAA;EA5CF;EA8CE;IACC,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EA5CH;EAiDA;IACC,eAAA;EA/CD;EAqDC;IACC,0BAAA;EAnDF;AACF;AAwDA;EAGG;IACC,eAAA;EAxDF;EA0DE;IACC,QAAA;IACA,WAAA;EAxDH;EA2DE;IACC,WAAA;IACA,YAAA;IACA,cAAA;EAzDH;EA2DG;IACC,gBAAA;IACA,WAAA;IACA,YAAA;IACA,YAAA;EAzDJ;EA+DA;IACC,SAAA;EA7DD;EA+DC;IACC,eAAA;EA7DF;AACF;AAkEA;EAKK;IACC,aAAA;EApEJ;AACF","sourcesContent":[".pageWrap {\r\n\t.pageHeader {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tpadding: 16px 24px;\r\n\t\tborder-bottom: 1px solid var(--border);\r\n\t\tmargin-bottom: 16px;\r\n\r\n\t\th1 {\r\n\t\t\tfont: var(--h3);\r\n\t\t\tfont-weight: 700;\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t\tfont-family: var(--font-bodoni-72);\r\n\t\t}\r\n\r\n\t\t.right {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 20px;\r\n\r\n\t\t\t.date {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tgap: 4px;\r\n\r\n\t\t\t\timg,\r\n\t\t\t\tsvg {\r\n\t\t\t\t\twidth: 16px;\r\n\t\t\t\t\theight: 16px;\r\n\t\t\t\t\tobject-fit: scale-down;\r\n\t\t\t\t\tdisplay: block;\r\n\t\t\t\t}\r\n\r\n\t\t\t\tspan {\r\n\t\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\tdisplay: block;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.tableWrap {\r\n\t\tpadding: 0 24px;\r\n\t}\r\n}\r\n\r\n.InviteModalInner {\r\n\t.csvAddRow {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tgap: 5px;\r\n\t\tmargin-bottom: 15px;\r\n\t}\r\n\r\n\t.addFieldWrp {\r\n\t\tmax-height: 300px;\r\n\t\toverflow-y: auto;\r\n\t}\r\n\r\n\t.addFieldRow {\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tgap: 15px;\r\n\t\tmargin-bottom: 15px;\r\n\t\twidth: 100%;\r\n\r\n\t\t.row {\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: space-between;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 8px;\r\n\t\t\twidth: 100%;\r\n\t\t\tpadding-top: 2px;\r\n\r\n\t\t\t.input {\r\n\t\t\t\tmax-width: 287px;\r\n\t\t\t\twidth: 100%;\r\n\t\t\t}\r\n\r\n\t\t\t.role {\r\n\t\t\t\tmin-width: 170px;\r\n\t\t\t}\r\n\r\n\t\t\t.deleteBtn {\r\n\t\t\t\twidth: 40px;\r\n\t\t\t\theight: 40px;\r\n\r\n\t\t\t\tbutton {\r\n\t\t\t\t\tpadding: 10px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.row > div:first-child {\r\n\t\t\tflex: 1;\r\n\r\n\t\t\t.input {\r\n\t\t\t\tmax-width: 100%;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.formWrp {\r\n\tmax-height: 550px;\r\n\toverflow-y: auto;\r\n\r\n\t.formField {\r\n\t\t.label {\r\n\t\t\tfont: var(--body-font-three);\r\n\t\t\tcolor: var(--secondary-Text);\r\n\t\t\tdisplay: block;\r\n\t\t\tmargin-bottom: 4px;\r\n\t\t}\r\n\t}\r\n\r\n\t.prioritySelect {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tgap: 5px;\r\n\t\tfont: var(--body-font-four);\r\n\t\tfont-weight: 500;\r\n\t\ttext-transform: capitalize;\r\n\t\tcolor: var(--primary-Text);\r\n\r\n\t\timg,\r\n\t\tsvg {\r\n\t\t\twidth: 16px;\r\n\t\t\theight: 16px;\r\n\t\t\tobject-fit: scale-down;\r\n\t\t\tdisplay: block;\r\n\t\t}\r\n\t}\r\n\r\n\t.fileUploadedList {\r\n\t\tpadding: 12px;\r\n\t\twidth: 100%;\r\n\t\tjustify-content: flex-start;\r\n\r\n\t\tspan {\r\n\t\t\tcolor: var(--brand);\r\n\t\t\tflex: 1;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.taskEditModal {\r\n\t.subHeading {\r\n\t\tfont-weight: 600;\r\n\t\tfont-size: var(--h6);\r\n\t\tcolor: var(--primary-Text);\r\n\t\tmargin-bottom: 20px;\r\n\t\ttext-align-last: left;\r\n\t}\r\n}\r\n\r\n.taskTitleInput {\r\n\twidth: 100%;\r\n\tborder: 1px solid var(--Stroke-Color, #E8EBEE);\r\n\tborder-radius: 8px;\r\n\tpadding: 8px 12px;\r\n\tbackground: #fff;\r\n\tfont: var(--body-font-three);\r\n\tcolor: #000;\r\n\tmargin: 0;\r\n\toutline: none;\r\n\r\n\t&::placeholder {\r\n\t\tcolor: var(--secondary-Text);\r\n\t}\r\n\r\n\t&:focus {\r\n\t\tborder-color: #7CA6BD;\r\n\t}\r\n}\r\n\r\n.taskDetailsModal {\r\n\t.subHeading {\r\n\t\tfont-weight: 600;\r\n\t\tfont-size: var(--h6);\r\n\t\tcolor: var(--primary-Text);\r\n\t\tmargin-bottom: 20px;\r\n\t\ttext-align-last: left;\r\n\t}\r\n\r\n\t.assignedToRow {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tgap: 16px;\r\n\t\tmargin-top: 4px;\r\n\r\n\t\tli {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 16px;\r\n\t\t\tmargin-bottom: 5px;\r\n\t\t\twidth: 40px;\r\n\t\t\theight: 40px;\r\n\t\t\tborder-radius: 50%;\r\n\t\t\toverflow: hidden;\r\n\r\n\t\t\timg,\r\n\t\t\tsvg {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\theight: 100%;\r\n\t\t\t\tdisplay: block;\r\n\t\t\t\tobject-fit: cover;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.dueDate {\r\n\t\tfont-weight: 500;\r\n\t\tfont-size: var(--body-font-three);\r\n\t\tcolor: var(--primary-Text);\r\n\t}\r\n\r\n\t.status {\r\n\t\tbackground-color: var(--white);\r\n\t}\r\n\r\n\t.comment {\r\n\t\tfont-weight: 500;\r\n\t\tfont-size: var(--body-font-three);\r\n\t\tcolor: var(--primary-Text);\r\n\t}\r\n\r\n\t.fileUploadedList {\r\n\t\tspan {\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.deleteModal {\r\n\t.modalBtns {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: center;\r\n\t\tgap: 16px;\r\n\t}\r\n}\r\n\r\n@media (max-height: 820px) {\r\n\t.formWrp {\r\n\t\tmax-height: 450px;\r\n\t\toverflow-y: auto;\r\n\t}\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\t.pageWrap {\r\n\t\t.pageHeader {\r\n\t\t\tpadding: 16px;\r\n\r\n\t\t\t.right {\r\n\t\t\t\tgap: 12px;\r\n\r\n\t\t\t\tbutton {\r\n\t\t\t\t\tmin-height: 35px;\r\n\t\t\t\t\tpadding: 7px 10px;\r\n\t\t\t\t\tfont-size: 12px;\r\n\t\t\t\t\ttext-align: center;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.tableWrap {\r\n\t\t\tpadding: 0 16px;\r\n\t\t}\r\n\t}\r\n\r\n\t.InviteModalInner {\r\n\t\t.csvAddRow {\r\n\t\t\tbutton {\r\n\t\t\t\tfont-size: 12px !important;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 600px) {\r\n\t.InviteModalInner {\r\n\t\t.addFieldRow {\r\n\t\t\t.row {\r\n\t\t\t\tflex-wrap: wrap;\r\n\r\n\t\t\t\t.role {\r\n\t\t\t\t\torder: 3;\r\n\t\t\t\t\twidth: 100%;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t.deleteBtn {\r\n\t\t\t\t\twidth: 35px;\r\n\t\t\t\t\theight: 35px;\r\n\t\t\t\t\tflex-shrink: 0;\r\n\r\n\t\t\t\t\tbutton {\r\n\t\t\t\t\t\tmin-height: auto;\r\n\t\t\t\t\t\twidth: 100%;\r\n\t\t\t\t\t\tpadding: 2px;\r\n\t\t\t\t\t\theight: 100%;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.row > div:first-child {\r\n\t\t\tflex: 1;\r\n\r\n\t\t\t.input {\r\n\t\t\t\tmax-width: 100%;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 425px) {\r\n\t.pageWrap {\r\n\t\t.pageHeader {\r\n\t\t\t.right {\r\n\t\t\t\t.date {\r\n\t\t\t\t\tspan {\r\n\t\t\t\t\t\tdisplay: none;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrap": `KazooTasksPage_pageWrap__itl6N`,
	"pageHeader": `KazooTasksPage_pageHeader__uzT2q`,
	"right": `KazooTasksPage_right__7AHzN`,
	"date": `KazooTasksPage_date__OZgLP`,
	"tableWrap": `KazooTasksPage_tableWrap__XR0WU`,
	"InviteModalInner": `KazooTasksPage_InviteModalInner__Pl0Ba`,
	"csvAddRow": `KazooTasksPage_csvAddRow__pKoXe`,
	"addFieldWrp": `KazooTasksPage_addFieldWrp__ZIa84`,
	"addFieldRow": `KazooTasksPage_addFieldRow__H25L1`,
	"row": `KazooTasksPage_row__Dfjrg`,
	"input": `KazooTasksPage_input__z4Pp9`,
	"role": `KazooTasksPage_role__o9cit`,
	"deleteBtn": `KazooTasksPage_deleteBtn__twMHk`,
	"formWrp": `KazooTasksPage_formWrp__x4IGS`,
	"formField": `KazooTasksPage_formField__RbjgL`,
	"label": `KazooTasksPage_label__OT6aC`,
	"prioritySelect": `KazooTasksPage_prioritySelect__kNt0x`,
	"fileUploadedList": `KazooTasksPage_fileUploadedList__Kdmqr`,
	"taskEditModal": `KazooTasksPage_taskEditModal__bB0FU`,
	"subHeading": `KazooTasksPage_subHeading__NF5PL`,
	"taskTitleInput": `KazooTasksPage_taskTitleInput__sNIKP`,
	"taskDetailsModal": `KazooTasksPage_taskDetailsModal__pN27G`,
	"assignedToRow": `KazooTasksPage_assignedToRow__XLL0b`,
	"dueDate": `KazooTasksPage_dueDate__ao+X9`,
	"status": `KazooTasksPage_status__KA99n`,
	"comment": `KazooTasksPage_comment__NSBLL`,
	"deleteModal": `KazooTasksPage_deleteModal__J3PqV`,
	"modalBtns": `KazooTasksPage_modalBtns__VKHWk`
};
export default ___CSS_LOADER_EXPORT___;
